// apps/client/src/ui/kit/Bubble.tsx
import type { ReactNode } from 'react';
export function Bubble(p: { name?: string; nameInk?: string; children: ReactNode }) {
  return <div className="bubble">{p.name && <span className="bubble-name" style={p.nameInk ? { color: p.nameInk } : undefined}>{p.name}</span>}{p.children}</div>;
}
